export default "__VITE_ASSET__3m9xdCsf__"